import { DataSourceCard } from './data-source-card';

interface ExternalDataSourceCardProps {
  actions?: React.ReactNode;
  authType: 'basic' | 'seamless' | 'sso';
  connectionUrl: string;
  isDisabled?: boolean;
  name: React.ReactNode;
  onConnect?: () => void;
}

const AuthType: Record<ExternalDataSourceCardProps['authType'], string> = {
  basic: 'DB credentials',
  seamless: 'Aura',
  sso: 'Single sign-on',
};

export function ExternalDataSourceCard(props: ExternalDataSourceCardProps) {
  return (
    <DataSourceCard actions={props.actions} isDisabled={props.isDisabled} name={props.name}>
      <div></div>
      <DataSourceCard.PropertyList>
        <DataSourceCard.PropertyDisplay label="Type" text="External" />
        <DataSourceCard.PropertyDisplay label="URL" text={props.connectionUrl} />
        <DataSourceCard.PropertyDisplay label="Auth" text={AuthType[props.authType]} />
      </DataSourceCard.PropertyList>
    </DataSourceCard>
  );
}
